import { lazy } from 'react';
import type { RouteObject } from 'react-router';
import { GuestOnly, RequireAuth } from '@/routes/guards';

// Páginas carregadas sob demanda (cada uma vira um pedaço separado do bundle)
const LoginPage = lazy(() => import('./pages/Login'));
const ForgotPasswordPage = lazy(() => import('./pages/ForgotPassword'));
const SecurityPage = lazy(() => import('./pages/Security'));
const MfaSetupPage = lazy(() => import('./pages/MfaSetup'));

/** Rotas do módulo Auth (login, recuperação, segurança, 2FA). */
const routes: RouteObject[] = [
  { path: '/entrar', element: <GuestOnly><LoginPage /></GuestOnly> },
  { path: '/recuperar-acesso', element: <GuestOnly><ForgotPasswordPage /></GuestOnly> },
  { path: '/conta/seguranca', element: <RequireAuth><SecurityPage /></RequireAuth> },
  { path: '/conta/seguranca/2fa', element: <RequireAuth><MfaSetupPage /></RequireAuth> },
];
export default routes;
